module.exports = "/virtual-football-league/img/amblems/left/logos/Mal.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Mal.png
// module id = 2109
// module chunks = 4